import {Injectable} from '@angular/core';
import {v4 as uuidv4} from 'uuid';

/** Identifies this running browser tab so its own API writes can be ignored. */
@Injectable()
export class ClientInstanceService {
  readonly id: string = uuidv4();
}



// WEBPACK FOOTER //
// ./src/services/signalR/client-instance.service.ts